import React, { useEffect, useState } from 'react';
import UtilService from '../../../services/util';
import _ from 'lodash';
import { FILE_URLS } from '../../../constants/Common';
import './simiarstone.less';
import { LISTINGPAGES } from '../../DiamondList/DiamondListFunctions';

const SimilarStone = (props) => {
  const [similar, setSimilar] = useState([]);

  useEffect(() => {
    let obj = {
      diamonds: props.id,
      page: 1,
      limit: 100,
    };

    let objData = {
      method: 'post',
      url: '/web/v1/match-pair/diamond',
      request: obj,
    };

    UtilService.callApi(objData, function (err, data) {
      if (err) throw err;
      else if (data && data.code === 'OK') {
        setSimilar(data.data.diamonds[0].data);
      }
    });
  }, [props]);

  return (
    <div className="similarStoneWrapper">
      {similar.length > 1 ? (
        <>
          {similar.map((s, i) => (
            <div
              key={i}
              className="similarStoneItem"
              onClick={() => {
                window.open('/' + LISTINGPAGES.DETAILS + '/' + s.vStnId, '_blank');
              }}
            >
              <img src={FILE_URLS.img.replace('***', s.mfgStnId)} alt="No Image Found" />
              <span>
                {s.shpNm} {s.crt} {s.colNm} {s.clrNm} {s.cutNm} {s.polNm}
                {s.symNm} {s.fluNm}
              </span>
            </div>
          ))}
        </>
      ) : (
        <p className="no-msg">No similar stones found.</p>
      )}
    </div>
  );
};
export default SimilarStone;
